module.exports = __webpack_public_path__ + "img/cases-part1-10.4d8ac03f.png";